export default __webpack_public_path__ + "static/media/style.9f222c24.less";